<template>
  <div class="close_wrap" @click="$emit('close')">
    <div class="logoArea">
      <img :src="require('../../assets/images/common/close_logo.jpg')" />
    </div>
    <div class="logoArea2">
      해당 부고는 발인되었습니다
    </div>
    <button class="btn_close_wrap" style="width:30px; height:30px">
      닫기
    </button>
  </div>
</template>

<script>
export default {
  name: "ObituaryEndCover"
};
</script>

<style>
.close_wrap {
  width: 100%;
  height: 120%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.75;
  filter: alpha(opacity=75);
  background: #000;
  z-index: 30;
  display: block;

  cursor: pointer;
}
.close_wrap .logoArea {
  position: fixed;
  top: 45%;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.close_wrap .logoArea img {
  width: 60px;
}
.close_wrap .logoArea2 {
  position: fixed;
  top: 55%;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-family: var(--noto5);
}
.close_wrap .logoArea2 p {
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
  top: 30px;
  color: #fff;
  width: 300px;
  font-size: 20px;
  font-family: var(--noto5);
}
.close_wrap button {
  position: fixed;
  top: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  background: url("../../assets/images/common/icon_cross.png") no-repeat 0 0;
  background-size: contain;
  text-indent: -10000px;
}
</style>
